<mat-card>{{'mandoobStatment' | translate}}</mat-card>

<div class="container" style="padding: 25px;">

  <mat-grid-list cols="8" rowHeight="50px">
    <mat-grid-tile colspan="2">
      <mat-form-field appearance="fill" class="example-form-field" style="margin: 10px;;">
        <mat-label>{{'mandoobName' | translate}}</mat-label>
        <mat-select [(value)]="selectedMandoob">
          <mat-option value="0">الرئيسي</mat-option>
          <mat-option *ngFor="let item of mandoobs" [value]="item.id">
            {{item.fullName}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile colspan="2">
      <mat-form-field appearance="fill" class="example-form-field">
        <mat-label>{{'enterDateRange' | translate}}</mat-label>
        <mat-date-range-input [rangePicker]="rangePicker">
          <input matStartDate placeholder="Start date" #fromDate>
          <input matEndDate placeholder="End date" #toDate>
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
        <mat-date-range-picker #rangePicker>
          <mat-date-range-picker-actions>
            <button mat-button matDateRangePickerCancel>{{'cancel' | translate}}</button>
            <button mat-raised-button color="primary" matDateRangePickerApply>{{'ok' | translate}}</button>
          </mat-date-range-picker-actions>
        </mat-date-range-picker>
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile colspan="2">
      <mat-form-field appearance="fill" class="example-form-field" style="margin: 10px;;">
        <mat-label>{{'mainServices' | translate}}</mat-label>
        <mat-select [(value)]="selectedMainService">
          <mat-option value="0">الكل</mat-option>
          <mat-option *ngFor="let item of mainService" [value]="item.id">
            {{item.arabicName}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile colspan="2">

      <button mat-raised-button color="primary" (click)="onApply()" [disabled]="selectedMandoob == undefined"
        style="margin-left: 10px;">
        <mat-icon>search</mat-icon>
        {{'filter' | translate}}
      </button>
      <!-- <button mat-raised-button color="primary" [disabled]="reports.length == 0" (click)="Print()">
        <mat-icon>print</mat-icon>
        {{'print' | translate}}
      </button> -->


    </mat-grid-tile>




  </mat-grid-list>

  <hr />

  <mat-grid-list cols="10" rowHeight="50px">

    <mat-grid-tile colspan="2">
      &nbsp;
      &nbsp;
      <mat-form-field>
        <mat-label>مجموع الكلفة</mat-label>
        <input matInput [value]="getTotalCostPrice()" readonly>
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile colspan="2">
      &nbsp;
      &nbsp;
      <mat-form-field>
        <mat-label>مجموع سعر البيع</mat-label>
        <input matInput [value]="getTotalPrice()" readonly>
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile colspan="2">
      &nbsp;
      &nbsp;
      <mat-form-field>
        <mat-label>مجموع المبالغ </mat-label>
        <input matInput [value]="getTotalAmount()" readonly>
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile colspan="2">
      &nbsp;
      &nbsp;
      <mat-form-field>
        <mat-label>مجموع العمولات</mat-label>
        <input matInput [value]="getTotalFees()" readonly>
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile colspan="2">
      &nbsp;
      &nbsp;
      <mat-form-field>
        <mat-label>الارباح</mat-label>
        <input matInput [value]="getProfit()" readonly>
      </mat-form-field>
    </mat-grid-tile>

  </mat-grid-list>

  <div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" matSort id="mandoobTable">

      <ng-container matColumnDef="orderId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'id' | translate}} </th>
        <td mat-cell *matCellDef="let row"> {{row.orderId}} </td>
        <!-- <td mat-footer-cell *matFooterCellDef></td> -->
      </ng-container>

      <ng-container matColumnDef="dateTime">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'dateTime' | translate}} </th>
        <td mat-cell *matCellDef="let row"> {{row.dateTime}} </td>
        <!-- <td mat-footer-cell *matFooterCellDef></td> -->
      </ng-container>

      <ng-container matColumnDef="userName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'name' | translate}} </th>
        <td mat-cell *matCellDef="let row"> {{row.userName}} </td>
        <!-- <td mat-footer-cell *matFooterCellDef></td> -->
      </ng-container>

      <ng-container matColumnDef="serviceName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'servicesName' | translate}} </th>
        <td mat-cell *matCellDef="let row"> {{row.serviceName}} </td>
        <!-- <td mat-footer-cell *matFooterCellDef></td> -->
      </ng-container>

      <ng-container matColumnDef="costPrice">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'costPrice' | translate}} </th>
        <td mat-cell *matCellDef="let row"> {{row.costPrice}} </td>
        <!-- <td mat-footer-cell *matFooterCellDef> {{'total' | translate}} </td> -->
      </ng-container>

      <ng-container matColumnDef="price">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'price' | translate}} </th>
        <td mat-cell *matCellDef="let row"> {{row.price}} </td>
        <!-- <td mat-footer-cell *matFooterCellDef> {{getTotalCost()}} </td> -->
        <!-- <td mat-footer-cell *matFooterCellDef> </td> -->
      </ng-container>

      <ng-container matColumnDef="amount">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'amount' | translate}} </th>
        <td mat-cell *matCellDef="let row"> {{row.amount}} </td>
        <!-- <td mat-footer-cell *matFooterCellDef></td> -->
      </ng-container>

      <ng-container matColumnDef="fees">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'fees' | translate}} </th>
        <td mat-cell *matCellDef="let row"> {{row.fees}} </td>
        <!-- <td mat-footer-cell *matFooterCellDef> {{getProfits()}} </td> -->
        <!-- <td mat-footer-cell *matFooterCellDef> </td> -->
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"
        [ngStyle]="{'background-color':row.status == 2 ? '#f0af3d' : '' }"></tr>
      <!-- <tr mat-footer-row *matFooterRowDef="displayedColumns; sticky: true"></tr> -->
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="4">{{'noDataMatchingTheFilter' | translate}}"</td>
      </tr>
    </table>


    <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
  </div>

</div>

<app-matspinner dir="rtl" [overlay]="spinnerOverlay"></app-matspinner>